import React from 'react';

const Packages = () => {
  const packages = [
    {
      id: 1,
      name: "Kiddies Package 1",
      price: "R600",
      duration: "45 min studio shoot",
      photos: "20 edited photos + 10 unedited photos",
      includes: ["Piano", "Car", "Chair"],
      note: "Outfits are not included, bring 2 outfits of your own."
    },
    {
      id: 2,
      name: "Kiddies Package 2",
      price: "R700",
      duration: "45 min studio shoot",
      photos: "20 edited photos + 10 unedited photos",
      includes: ["Milk Bath", "Piano", "Car", "Chair"],
      note: "Outfits are not included, bring 2 outfits of your own."
    },
    {
      id: 3,
      name: "Kiddies Package 3",
      price: "R1000",
      duration: "45 min studio shoot",
      photos: "20 edited photos + 10 unedited photos",
      includes: ["Cake Smash (small cake included)", "Milk Bath", "Piano", "Car", "Chair"],
      note: "Outfits are not included, bring 2 outfits of your own."
    },
    {
      id: 4,
      name: "Adults Birthday - Basic",
      price: "R400",
      duration: "Studio shoot",
      photos: "10 edited photos",
      includes: ["Professional lighting", "Background options"],
      note: "Includes one person only"
    },
    {
      id: 5,
      name: "Adults Birthday - Deluxe",
      price: "R600",
      duration: "Studio shoot",
      photos: "20 edited photos",
      includes: ["Decor included", "Professional lighting", "Background options"],
      note: "Includes up to 3 people"
    },
    {
      id: 6,
      name: "Family Shoot",
      price: "R150 per person",
      duration: "Studio shoot",
      photos: "5 photos per person (total of 30 edited photos for 5 people)",
      includes: ["Group poses", "Individual shots", "Professional editing"],
      note: "5 people per shoot. One outfit of your choice."
    }
  ];

  return (
    <section id="packages" className="packages">
      <div className="container">
        <h1 className="section-title">Our Photography Packages</h1>
        <div className="packages-grid" itemScope itemType="https://schema.org/OfferCatalog">
          {packages.map(pkg => (
            <article key={pkg.id} className="package-card" itemScope itemType="https://schema.org/Offer">
              <div className="package-header">
                <h2 itemprop="name">{pkg.name}</h2>
                <div className="package-price" itemprop="price" itemContent={pkg.price.replace('R', '')}>
                  {pkg.price}
                </div>
                <meta itemprop="priceCurrency" content="ZAR" />
              </div>
              <div className="package-details" itemprop="description">
                <p>{pkg.duration}</p>
                <p>{pkg.photos}</p>
                <div className="includes">
                  <h3>Includes:</h3>
                  <ul>
                    {pkg.includes.map((item, index) => (
                      <li key={index}>• {item}</li>
                    ))}
                  </ul>
                </div>
                <div className="package-note">
                  <p><strong>N.B.</strong> {pkg.note}</p>
                </div>
              </div>
              <button className="btn package-btn">
                Select Package
              </button>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};


export default Packages;